import MxTypography from "@rf-l1/MxTypography";
import React from "react";

const MxDetailTitle = ({ label }: { label: string }) => {
  return (
    <MxTypography variant="h4" color="primary.main">
      {label}
    </MxTypography>
  );
};

export default MxDetailTitle;
